export enum CleaningFrequency {
  ONETIME = "oneTime",
  UNKNOWN = "unknown",
  WEEKLY = "weekly",
  BIWEEKLY = "biWeekly",
  MONTHLY = "monthly",
}
